import { ICreateSettlementFeeForm } from 'types/order/fees/ICreateSettlementItemForm';
import { eFeePropertyNames } from 'types/order/fees/eFeePropertyNames';
import { v4 } from 'uuid';
import { calculateAmountCentsToDisburse } from './calculateAmountCentsToDisburse';
import { defaultMemo } from './defaultMemo';
import { IOrderDetailsData } from '../../../../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const defaultCreate = (
  fee: ICreateSettlementFeeForm,
  order: IOrderDetailsData,
  isSpruceWithZillowEnabled: boolean,
  isZillowClosing: boolean
) => {
  const beneficiary = fee.stringFeePropertyValues[eFeePropertyNames.Payee];

  const amountCents = calculateAmountCentsToDisburse(fee.numericFeePropertyValues, fee.stringFeePropertyValues);

  const memo = defaultMemo(order, isSpruceWithZillowEnabled, isZillowClosing);

  return { id: v4(), isNew: true, statementFeeId: fee.statementFeeId, amountCents, beneficiary, memo };
};
